import { Stroke, Style, Circle, Fill } from "ol/style";

export function getNodeStyleNormal(feature, editMode = false) {
  return getNodeStyle(feature, false, false, editMode);
}
export function getNodeStyleClick(feature) {
  return getNodeStyle(feature, true, false, true);
}
export function getNodeStyleHover(feature) {
  return getNodeStyle(feature, false, true, true);
}

function isConnector(feature) {
  return feature
    .getKeys()
    .some((key) => key.endsWith("-connector") && feature.get(key) === "yes");
}

function getNodeStyle(feature, click, hover, editMode) {
  if (feature.getGeometry().getType() !== "Point") {
    return [];
  }

  const connector = isConnector(feature);

  // In normal mode, only show connectors. In edit mode, show all nodes.
  if (!editMode && !connector) {
    return [];
  }

  let radius, strokeColor, fillColor;
  if (connector) {
    radius = editMode ? 8 : 3;
    strokeColor = "grey";
    fillColor = "pink";
  } else {
    radius = editMode ? 5 : 2;
    strokeColor = "green";
    fillColor = "white";
  }

  if (hover) {
    radius = editMode ? 10 : 6;
  }
  if (click) {
    fillColor = "orange";
    radius = editMode ? 10 : 6;
  }

  return [
    new Style({
      image: new Circle({
        fill: new Fill({ color: fillColor }),
        stroke: new Stroke({ color: strokeColor, width: 1 }),
        radius: radius,
      }),
    }),
  ];
}
